import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialoglogin";
import UsdCoinIcon from "@/icons/withdraw/coins/usdCoinIcon";
import USDTIcon from "@/icons/withdraw/coins/usdtIcon";
import UsdIcon from "@/icons/withdraw/usd";
import { getCdnUrl } from "@/lib/utils";
import DepositTab from "@/pages/Wallet/DepositTab";
import TransactionTable from "@/pages/Wallet/Transactions";
import WithdrawalForm from "@/pages/Wallet/Withdrawal";
import { ArrowRightIcon } from "lucide-react";
import { useState } from "react";

interface WalletDialogProps {
  trigger: React.ReactNode;
  initialActiveButton?: string;
}

const WalletDialog = ({ trigger, initialActiveButton }: WalletDialogProps) => {
  const [activeButton, setActiveButton] = useState(initialActiveButton);
  const [isOpen, setIsOpen] = useState(false); // State to control open/close of modal
  const [isSuccess, setIsSuccess] = useState(false);
  const [isReject, setIsReject] = useState(false);
  const [wdUsdAmount, setWdUsdAmount] = useState("0");
  const [wdUsdtAmount, setWdUsdtAmount] = useState("0");

  const closeDialog = () => {
    setIsOpen(false);
    setIsSuccess(false);
    setIsReject(false);
  };

  const renderContent = () => {
    switch (activeButton) {
      case "deposit":
        return <DepositTab />; // Replace with actual form
      case "withdrawal":
        return (
          <WithdrawalForm
            onWithdrawalSuccess={(usdAmount: string, usdtAmount: string) => {
              setWdUsdAmount(usdAmount);
              setWdUsdtAmount(usdtAmount);
              setIsSuccess(true);
            }}
            onPendingWithdrawalExist={() => setIsReject(true)}
          />
        ); // Replace with actual form
      // case "transactions":
      //   return <TransactionTable />; // Replace with actual table or content
      default:
        return null;
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        onClose={closeDialog}
        className={`wallet-width max-h-[95vh] overflow-auto bg-[url('/login/login-back.png')] bg-cover text-white/30`}
      >
        {isSuccess ? (
          <WithdrawalSuccessView
            usdAmount={wdUsdAmount}
            usdtAmount={wdUsdtAmount}
          />
        ) : isReject ? (
          <WithdrawalRejectView />
        ) : (
          <div
            className={`max-h-[70vh grid grid-cols-1 gap-4 overflow-y-auto md:grid-cols-1`}
          >
            {/* Left Column for the Form */}
            <div className="flex w-full flex-col rounded-l-lg p-2 text-white ">
              <div className="mb-2 font-sans text-[28px] font-bold max-sm:hidden">
                Wallet
              </div>
              <div className="mb-2 flex items-center bg-white/5 max-md:mt-4 sm:rounded-lg sm:border-2 sm:border-solid sm:border-white/5 sm:p-1">
                <Button
                  className={`flex-grow ${
                    activeButton === "deposit"
                      ? "bg-button-gradient text-white"
                      : "bg-transparent text-white/50"
                  } rounded-none px-4 py-2 text-sm font-normal sm:rounded-lg sm:font-bold`}
                  onClick={() => setActiveButton("deposit")}
                >
                  Deposit
                </Button>
                <Button
                  className={`flex-grow ${
                    activeButton === "withdrawal"
                      ? "bg-button-gradient text-white"
                      : "bg-transparent text-white/50"
                  } rounded-none px-3 py-2 text-sm font-normal sm:rounded-lg sm:font-bold`}
                  onClick={() => setActiveButton("withdrawal")}
                >
                  Withdrawals
                </Button>
                {/* <Button */}
                {/*   className={`flex-grow ${ */}
                {/*     activeButton === "transactions" */}
                {/*       ? "bg-button-gradient text-white" */}
                {/*       : "bg-transparent text-white/50" */}
                {/*   } rounded-none px-3 py-2 text-sm font-normal sm:rounded-lg sm:font-bold`} */}
                {/*   onClick={() => setActiveButton("transactions")} */}
                {/* > */}
                {/*   Transactions */}
                {/* </Button> */}
              </div>
              {/* {activeButton === "deposit" ? <LoginForm /> : <SignupForm />} */}
              {renderContent()}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

interface WithdrawalSuccessViewProps {
  usdAmount: string;
  usdtAmount: string;
}
const WithdrawalSuccessView = ({
  usdAmount,
  usdtAmount,
}: WithdrawalSuccessViewProps) => {
  return (
    <div className="flex flex-col items-center gap-4 text-center text-white">
      <img
        className="h-[120px]"
        src={getCdnUrl("assets/icons/check.png")}
        alt="check-icon"
      />
      <h3 className="text-2xl font-[500]">Withdrawal Request Sent!</h3>
      <p>
        Your withdrawal request is in process for 2-4 business days. When the
        request approved, funds will immediately send to your account.
      </p>
      <div className="flex items-center justify-center gap-8 text-xs font-thin">
        <div className="flex items-center gap-2">
          <UsdCoinIcon size={24} />
          {usdAmount ?? 0} USD
        </div>
        <ArrowRightIcon />
        <div className="flex items-center gap-2">
          <USDTIcon size={24} />
          {usdtAmount ?? 0} USDT
        </div>
      </div>
    </div>
  );
};

const WithdrawalRejectView = () => {
  return (
    <div className="flex flex-col items-center gap-4 text-center text-white">
      <img
        className="h-[120px]"
        src={getCdnUrl("assets/icons/timesand.png")}
        alt="check-icon"
      />
      <h3 className="text-2xl font-[500]">Can’t Request A Withdrawal</h3>
      <p>
        There is a Pending Withdrawal at the moment. You can request a
        withdrawal when the Pending Withdrawal is approved or canceled.
      </p>
    </div>
  );
};

export default WalletDialog;
